import { QuestionsActionConstants, SubmissionActionConstants, QUIZ_API_URL } from '../constants';
import * as Cookie from 'js-cookie';
const agent = require('superagent-promise')(require('superagent'), Promise);

export const getQuestions = () => {
  return dispatch => {
    return agent.get(`${QUIZ_API_URL}questions/`)
      .then(json => dispatch(questionsReceived(json)));
  };
};

export const questionsReceived = (jsonData) => ({
  type: QuestionsActionConstants.QUESTIONS_RECEIVED,
  questions: jsonData.body.questions
});

export const loadSubmission = () => {
  return dispatch => {
    return agent.get(`${QUIZ_API_URL}submission/`)
      .then(json => dispatch(submissionReceived(json)))
      .catch(err => {});
  };
};

export const startSubmission = (name) => {
  return dispatch => {
    dispatch(loadingSubmission());
    return agent.post(`${QUIZ_API_URL}submission/`)
      .set('X-CSRFToken', Cookie.get('csrftoken'))
      .send({ name })
      .then(json => dispatch(submissionReceived(json)))
      .catch(err => {});
  };
};

export const loadingSubmission = () => ({
  type: SubmissionActionConstants.LOADING_SUBMISSION
});

export const submissionReceived = (jsonData) => ({
  type: SubmissionActionConstants.SUBMISSION_RECEIVED,
  submission: jsonData.body
});

export const answerSubmission = (question, answer) => {
  return dispatch => {
    return agent.put(`${QUIZ_API_URL}submission/answer/`)
      .set('X-CSRFToken', Cookie.get('csrftoken'))
      .send({ question, answer })
      .then(json => dispatch(submissionReceived(json)))
      .catch(err => {});
  };
};

export const skipQuestion = () => ({
  type: SubmissionActionConstants.SKIP_QUESTION
});

export const submitSubmission = () => {
  return dispatch => {
    return agent.post(`${QUIZ_API_URL}submission/submit/`)
      .set('X-CSRFToken', Cookie.get('csrftoken'))
      .then(json => dispatch(submissionReceived(json)))
      .catch(err => {});     
  };
};




// WEBPACK FOOTER //
// ./src/actions/index.js